import { createContext, useContext } from 'react';

/** Contexto lido pelo `PageHead` dentro de uma aba: onde projetar as `actions` e se a aba está ativa. */
export const AbaContext = createContext<{ slot: HTMLElement | null; ativa: boolean } | null>(null);
export function useAbaContext(): { slot: HTMLElement | null; ativa: boolean } | null {
  return useContext(AbaContext);
}
